var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b636d8e0-5157-4a66-8750-2bf74fd3f371",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fafcae55-b2a2-480f-8d98-329f7f50b46c{fill:#d99938;}.a7c61a68-4959-4bd8-82cc-edb3ce49e9de{fill:#292d32;opacity:0.4;isolation:isolate;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fafcae55-b2a2-480f-8d98-329f7f50b46c",
    d: "M243.55247,385.18859H55.80533c3.2025-186.94772,40.031-217.77228,154.921-285.82561a28.01066,28.01066,0,1,0-28.82379-48.03726C46.5965,131.38847-.64051,180.226-.64051,413.21055V628.97963A123.77787,123.77787,0,0,0,123.05763,752.67658H243.15177c70.45519,0,123.69454-53.24172,123.69454-123.69695V508.88554C367.2466,438.43032,314.0077,385.18859,243.55247,385.18859Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a7c61a68-4959-4bd8-82cc-edb3ce49e9de",
    d: "M676.70113,385.18859H488.954C492.15651,198.24087,528.98938,167.41631,643.87938,99.363a28.01137,28.01137,0,1,0-28.82653-48.03726C479.7468,131.38847,432.50977,180.226,432.50977,413.21055V628.97963a123.78026,123.78026,0,0,0,123.701,123.69695H676.30485c70.45523,0,123.69291-53.24172,123.69291-123.69695V508.88554C800.39808,438.43032,747.15636,385.18859,676.70113,385.18859Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.71d06770.svg";
export { ForwardRef as ReactComponent };